import { setupAnalytics } from './analytics/default';
import { getElementDataset } from '../utilities/dataRetrieval';
import { marketNewsArticleView } from './analytics/events/markets';

const analytics = setupAnalytics();
const eventData = getElementDataset({ selector: '[data-news-article]' }) || {};
analytics.trackEvent(marketNewsArticleView(eventData));
